import React, {useContext, useEffect, useState} from "react";
import c from "./QuizViewer.module.scss";
import {Link, useParams} from "react-router-dom";
import Helpers from "../../helpers/Helpers";
import SiteService from "../../services/SiteService";
import Checkbox from "../../components/ui/Checkbox";
import BackButton from "../../components/ui/BackButton";
import adminQuizService from "../../services/AdminQuizService";
import UserContext from "../../store/userContext";

const QuizViewer = ({part, quizId, backButtonEnabled=false }) => {
	const [quiz, setQuiz] = useState(null);
	quizId = part?.value || quizId || useParams().quizId;
	const [currentStep, setCurrentStep] = useState(0);
	const [completed, setCompleted] = useState(false);
	const [wasAlreadyCompleted, setWasAlreadyCompleted] = useState(false);

	const role = useContext(UserContext).role;

	const fetchQuiz = async () => {
		let req = await Helpers.searchPaginated('quiz',{_id: quizId});
		if (req.mainObj)
			setQuiz(req.mainObj[0]);
	}

	useEffect(() => {
		if (quizId && !quiz){
			fetchQuiz();
		}
	}, []);


	// Track user's answers
	const [userAnswers, setUserAnswers] = useState(null);
	useEffect(() => {
		let storedQuizAnswers = JSON.parse(localStorage.getItem('quizAnswers'));
		if (quiz && quiz.settings.type === 'opinionPoll' && quiz.steps && quiz.steps.length > 0 && storedQuizAnswers && storedQuizAnswers[quizId]){
			setUserAnswers(storedQuizAnswers[quizId]);
			setWasAlreadyCompleted(true);
			setCompleted(true);
		}
		else if (!userAnswers && quiz && quiz.steps && quiz.steps.length > 0) {
			setUserAnswers(
				{...quiz.steps[0].questions.reduce((acc, question) => ({...acc, [question._id]: {
					selectedAnswer: null, isCorrect: false
				}}), {})}
			);
		}
	}, [quiz]);

	console.log(userAnswers)
	console.log('completed:', completed);

	const saveQuizAnswerInLocalStorage = () => {
		let storedQuizAnswers = JSON.parse(localStorage.getItem('quizAnswers')) || {};
		storedQuizAnswers[quizId] = userAnswers;
		localStorage.setItem('quizAnswers', JSON.stringify(storedQuizAnswers));
	}

	// Handle answer selection
	const handleAnswerSelect = (stepIndex, questionIndex, answerIndex, value) => {
		if (completed) return;
		const updatedAnswers = {...userAnswers};

		let questionId = quiz.steps[stepIndex].questions[questionIndex]._id;
		if (!updatedAnswers[questionId])
			updatedAnswers[questionId] = {};

		if (value)
			updatedAnswers[questionId].selectedAnswer = value;
		else
			updatedAnswers[questionId].selectedAnswer = answerIndex;

		if (quiz.steps[stepIndex].questions[questionIndex].type === "multipleChoice") {
			if (quiz.steps[stepIndex].questions[questionIndex].answers[answerIndex].correct) {
				updatedAnswers[questionId].isCorrect = true;
			}
		}

		setUserAnswers(updatedAnswers);
	};

	// Move to the next step or finish the quiz
	const handleStepChange = async (change) => {
		if ((currentStep + change) < quiz.steps.length) {
			setCurrentStep(currentStep + change);
		} else {
			await adminQuizService.submitAnswers(quizId,userAnswers);
			if (quiz.settings.type === 'opinionPoll') {
				saveQuizAnswerInLocalStorage();
				await fetchQuiz();
			}
			setCompleted(true);
		}
	};

	const calculateScore = () => {
		let score = 0;
		Object.keys(userAnswers).forEach((key, i)=>{
			if (userAnswers[key].isCorrect)
				score++;
		});
		return score;
	}

	const getQuestionCount = ()=>{
		let questionCount = 0;
		for (let i = 0; i < quiz.steps.length; i++) {
			const currQuestions = quiz.steps[i].questions;
			for (let i2 =0; i2 < currQuestions.length; i2++ ){
				let currQuestion = currQuestions[i2];
				if (currQuestion.type === "trueFalse") {
					continue;
				}
				questionCount += 1;
			}
		}
		return questionCount;
	}
	const getScorePercentage = () => {
		return Math.round((calculateScore() / getQuestionCount()) * 100);
	}

	const getImageSrc = (imgName) => {
		return `${SiteService.apiPath}/image/quiz/${quizId}/${imgName}`
	}



	function Answer({answer, answerIndex, question, questionIndex}) {
		if (question.type === "trueFalse") return(<>
			<span>{" - "}</span> <Checkbox state={userAnswers[question._id]?.selectedAnswer}
					  changeFunc={(newVal)=>handleAnswerSelect(currentStep, questionIndex, null, newVal)}
					  label={'Ja'}
			/>
		</>)

		else if (!answer.type || answer.type === "multipleCoice"){
			let isSelectedAnswer = userAnswers[question._id]?.selectedAnswer === answerIndex;
			let hasAnswered = userAnswers[question._id]?.selectedAnswer !== null;
			let submissionsTotal = 0;
			question.answers.forEach((answer) => {submissionsTotal+=answer.submissionCount||0});
			let percentageTotal =  Math.round((answer.submissionCount / submissionsTotal) * 100);
		return(
		<button
			key={answerIndex}
			className={`${c.answer} ${isSelectedAnswer ? c.selected : ""}`}
			onClick={() => handleAnswerSelect(currentStep, questionIndex, answerIndex)}
		>
			{(hasAnswered&&completed)&&<div className={c.answerPercentageInlay} style={{width:percentageTotal+'%'}}/>}
			<div>{answer.text}</div>
			{(hasAnswered&&completed)&&<div className={c.answerPercentageGroup}>
				<span>{answer.submissionCount||0} stemmer</span>
				<b>{percentageTotal+'%'}</b>
			</div>}
		</button>
	)}}



	if (completed&&quiz.settings.type==="quiz") {return (<div className={c.root}>
			<div className={c.result}>
				<h2>Quiz Ferdig!</h2>
				<p>Din Score: {calculateScore()} / {getQuestionCount()}</p>
				<p>Prosent Riktige: {getScorePercentage()}%</p>
				{getScorePercentage()==100&&<p><b>Gratulerer! Du har alt riktig!</b></p>}
			</div>
	</div>);
	}else if(completed&&quiz.settings.type==="form") {return (<div className={c.root}>
		<div className={c.result}>
			<h2>Skjema ferdig</h2>
		</div>
	</div>);
	}

		if (!quiz || !quiz.steps || !userAnswers) return <div>Laster...</div>;

		const step = quiz.steps[currentStep];

		return (<>
		<div className={c.root}>
			{backButtonEnabled && <BackButton className={c.backButton}/>}
			{role > 0 && <div className={c.adminLinks}><Link to={`/admin/quizer/${quizId}`}>Rediger</Link>
				<Link to={`/admin/quizer/${quizId}/innsendinger`}>Innsendinger</Link></div>}
			<h2>{quiz.name}</h2>
			{quiz.image && <img src={getImageSrc(quiz.image)} className={c.stepImage}/>}
			{currentStep < 1 && <div>{quiz.description}</div>}

			{/*quiz.steps.length>1&&<h3>Steg {currentStep + 1}: {step.name}</h3>*/}
			{step.image && <img src={getImageSrc(step.image)} alt={step.name} className={c.stepImage}/>}

			{step.questions.map((question, questionIndex) => (
				<div key={questionIndex} className={c.question}>
					<div className={c.questionText}>{question.text}</div>
					{question.image && <img src={getImageSrc(question.image)} className={c.questionImage}/>}
					{question.type === 'freeText' && <input type="text" className={c.answer} placeholder="Svar"
															onChange={(e) => {
																handleAnswerSelect(currentStep, questionIndex, null, e.currentTarget.value)
															}}
					/>}
					{question.type === 'trueFalse' && <Answer question={question} questionIndex={questionIndex}/>}
					{question.type !== 'freeText' && question.answers.map((answer, answerIndex) => (
						<Answer answer={answer} answerIndex={answerIndex}
								question={question} questionIndex={questionIndex}
								key={answerIndex}
						/>
					))}
				</div>
			))}

			{!completed && <div>
				{(quiz?.settings?.allowBackwardStep && currentStep > 0) &&
					<button onClick={() => handleStepChange(-1)} className={c.nextButton}>
						Forrige
					</button>}
				<button onClick={() => handleStepChange(1)} className={c.nextButton}>
					{currentStep < quiz.steps.length - 1 ? "Neste" : <>{quiz.settings.type === 'opinionPoll' ? 'Stem' : "FERDIG"}</>}
				</button>
			</div>}
		</div>
	</>
		);
		};

		export default QuizViewer;
